export const getByPath = (obj: unknown, path?: string): unknown => {
  if (!path) return undefined;
  return path
    .split('.')
    .reduce<unknown>(
      (o, k) => (o != null ? (o as Record<string, unknown>)[k] : undefined),
      obj
    );
};

export const setByPath = (
  obj: Record<string, unknown>,
  path: string,
  value: unknown
): void => {
  const parts = path.split('.');
  let cur: Record<string, unknown> = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i];
    const next = cur[key];
    cur[key] =
      next != null && typeof next === 'object' && !Array.isArray(next)
        ? (next as Record<string, unknown>)
        : {};
    cur = cur[key] as Record<string, unknown>;
  }
  cur[parts.at(-1)!] = value;
};
